angular.module("app").directive("whatsappSite", function ($sce) {
  return {
    restrict: "E",
    template: `
            <a href="{{getHref()}}" ng-click="onClick()" target="_blank" class="whats botao-wpp d-none d-xl-block"><i class="fab fa-whatsapp text-3"></i> Atendimento</a>
            <a href="{{getHref()}}" ng-click="onClick()" target="_blank" class="whats botao-wpp-mini d-block d-sm-none"><i class="fab fa-whatsapp"></i></a>
        `,
    scope: {},
    controller: function ($scope, $element, $http, $timeout, $compile) {
      $scope.onClick = function () {
        gtag("event", "conversion", {
          send_to: "AW-16618848385/otmCCOfs578ZEIGBvvQ9",
          value: 1.0,
          currency: "BRL",
        });
      };

      $scope.detectMob = function () {
        var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

        return isMobile;
      };

      $scope.getHref = function () {
        var link = "web";
        if ($scope.detectMob()) {
          link = "api";
        }
        $scope.href =
          "https://" +
          link +
          ".whatsapp.com/send?phone=5531981180329&text=Olá%20SisBuffet! ";
        return $scope.href;
      };
    },
    link: function ($scope, $element, attrs, ctrl) {},
  };
});
